module.exports = __webpack_public_path__ + "img/icon-recruitment.5ea2a445.svg";